import base from './base.repository';
import base2 from './base2.repository';

export default {
    ...base,
    get: filters => base2.get('venues', filters),
    async loadVenuesByClient(clientId, filters, page){
        const params = {...filters, page: page, client: clientId};
        const {data} = await base2.get(`venues`, params);
        return data;
    },
    saveVenue(venue) {
        this.post(`venues`, venue);
        return this;
    },
    updateVenue(venue, id) {
        this.put('venues/' + id, venue);
        return this;
    },
    deleteVenue(id){
        this.delete('venues/'+ id);
        return this;
    },
    getVenueUsers: (venueId) => base2.get(`venues/${venueId}/users`),
    saveVenueUsers: (users, id) => base2.post(`venues/${id}/users`, { users }),
}